
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

export enum Environment {
    PROD = 'PROD',
    INT = 'INT',
    DEV = 'DEV',
    LOCAL = 'LOCAL',
    CYPRESS = 'CYPRESS',
  }

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    constructor() {}

    private _env!: Environment;
    private _apiUrl!: string;

    setEnvironmentUrlViaSubdomain(): void {
      const hostname = window && window.location && window.location.hostname;
      const port = window && window.location && window.location.port;
      if (/^fcs-c/.test(hostname)) {
        // this domain is used inside of the docker compose environment
        this._env = Environment.CYPRESS;
        environment.commonApiUrl = '/';
      } else if (/^.*localhost.*/.test(hostname)) {
        if ("8080" === (port as string)) {
          this._env = Environment.CYPRESS;
          environment.commonApiUrl = '/';
        } else {
          this._env = Environment.LOCAL;
          environment.commonApiUrl = 'https://api.fcsc-dev.vus.corpinter.net/';
        }
      } else if (/^fcsc-dev.vus.corpinter.net/.test(hostname)) {
        this._env = Environment.DEV;
        environment.commonApiUrl = 'https://api.fcsc-dev.vus.corpinter.net/';
      } else if (/^fcsc-int.vus.corpinter.net/.test(hostname)) {
        this._env = Environment.INT;
        environment.commonApiUrl = 'https://api.fcsc-int.vus.corpinter.net/';
      } else if (/^fcsc.vus.corpinter.net/.test(hostname)) {
        this._env = Environment.PROD;
        environment.commonApiUrl = 'https://api.fcsc.vus.corpinter.net/';
      } else {
        console.warn(`Cannot find environment for host name ${hostname}`);
      }
    }
}